import React from 'react'
import { withRouter } from 'react-router-dom'
import { Card, Button } from 'antd-mobile'
import { YenSpan } from '../common/YenSpan'
import { useTranslation, withTranslation } from 'react-i18next'

const ThumbItem = (item) => {
  return <div className={'item-card__thumb item-card__thumb--gutter'}>
    <img src={item['imgSrc']} alt=""/>
    <span>{item['amount']}</span>
  </div>
}

const ThumbMore = () => {
  const { t } = useTranslation()
  return <div className={'item-card__thumb-more'}>
    <div><i className={'icon-font icon-arrow-right-bold'}/></div>
    <div>{t('common.more')}</div>
  </div>
}

@withTranslation()
@withRouter
class OrderListItem extends React.PureComponent {
  static defaultProps = {
    orderId: '',
    total: '0',
    amount: '',
    status: '',
    statusText: '',
    deliveryNumber: '',
    createdTime: '',
    productList: [],
    showCancelButton: true,
    onOrderClick: function () {}
  }

  render () {
    const {
      t,
      orderId, amount, total, status, statusText, productList
    } = this.props
    let product = {}
    if (productList.length === 1) {
      product = productList[0]
    }
    return <Card className={'m-4'}>
      {/*<Card.Header title={`${t('order.num')}： ${orderId}`}*/}
      {/*             extra={<span className={'item-card__header'}>{statusText}</span>}/>*/}
      <div className={'flex justify-between items-center h-8 border-b'}>
        <div className={'text-sm'}>{`${t('order.num')}： ${orderId}`}</div>
        <div className={'text-orange-400'}>{statusText}</div>
      </div>
      {/*<Card.Body onClick={this.goToDetails}>*/}
      {/*  {*/}
      {/*    productList.length === 1*/}
      {/*      ? <Flex align={'start'}>*/}
      {/*        <img className={'item-card__thumb'} src={product['imgSrc']} alt=""/>*/}
      {/*        <div className={'item-card__content'}>*/}
      {/*          <div className="item-card__title">*/}
      {/*            {product['name']}*/}
      {/*          </div>*/}
      {/*          <Flex justify={'between'}>*/}
      {/*            <YenSpan className="item-card__price">{product['price']}</YenSpan>*/}
      {/*            <div className="item-card__amount">*/}
      {/*              x {amount}*/}
      {/*            </div>*/}
      {/*          </Flex>*/}
      {/*        </div>*/}
      {/*      </Flex>*/}
      {/*      : <Flex align={'center'}>*/}
      {/*        {*/}
      {/*          productList.map((item, index) => {*/}
      {/*            if (index < 2 || (index === 2 && productList.length === 3)) {*/}
      {/*              return <ThumbItem {...item} key={index}/>*/}
      {/*            } else if (index === 2) {*/}
      {/*              return <ThumbMore key={index}/>*/}
      {/*            } else {*/}
      {/*              return null*/}
      {/*            }*/}
      {/*          })*/}
      {/*        }*/}
      {/*      </Flex>*/}
      {/*  }*/}
      {/*</Card.Body>*/}
      <div className={'p-4'} onClick={this.goToDetails}>
        {
          productList.length === 1
            ? <div className={'flex'}>
              <img className={'h-auto w-24'} src={product['imgSrc']} alt=""/>
              <div className={'flex-auto ml-4'}>
                <div className={'line-clamp-2 mb-4'}>
                  {product['name']}
                </div>
                <div className={'flex justify-between'}>
                  <YenSpan>{product['price']}</YenSpan>
                  <div className={'text-sm'} style={{ color: 'var(--adm-color-weak)' }}>
                    x {amount}
                  </div>
                </div>
              </div>
            </div>
            : <div className={'flex'}>
              {
                productList.map((item, index) => {
                  if (index < 2 || (index === 2 && productList.length === 3)) {
                    return <ThumbItem {...item} key={index}/>
                  } else if (index === 2) {
                    return <ThumbMore key={index}/>
                  } else {
                    return null
                  }
                })
              }
            </div>
        }
      </div>
      {/*<Card.Footer*/}
      {/*  content={<span className={'item-card__footer'}>{amount}件 {t('order.total')}: <YenSpan>{total}</YenSpan></span>}*/}
      {/*  extra={this.renderButton(status)}*/}
      {/*/>*/}
      <div className={'flex justify-between items-center'} style={{ color: 'var(--adm-color-weak)' }}>
        <div className={'leading-2'}>{amount}件 {t('order.total')}: <YenSpan>{total}</YenSpan></div>
        <div>
          {this.renderButton(status)}
        </div>
      </div>
    </Card>
  }

  renderButton = statusCode => {
    // 7/14/2020 暂时在list里取消cancel
    // const { showCancelButton } = this.props
    const { t } = this.props
    let s = statusCode.toString()
    let jsx = null
    switch (s) {
      case '1':
        jsx = <div>
          {/*{*/}
          {/*  showCancelButton*/}
          {/*    ? <Button type={'ghost'} size={'small'} inline*/}
          {/*      onClick={this.onOrderCancel}>取消订单</Button>*/}
          {/*    : null*/}
          {/*}*/}
          {/*&nbsp;*/}
          <Button color={'danger'} size={'mini'} onClick={this.onOrderPay}>{t('order.pay')}</Button>
        </div>
        break
      case '2' :
      case '3':
        // jsx = <Button type={'ghost'} size={'small'} inline onClick={this.onOrderConfirm}>确认收货</Button>
        break
      default:
    }
    return jsx
  }

  // onOrderCancel = () => {
  //   this.props.onOrderClick('cancel', this.props.orderId)
  // }
  //
  // onOrderConfirm = () => {
  //   this.props.onOrderClick('confirm', this.props.orderId)
  // }

  goToDetails = () => {
    this.props.history.push(`${window.PATH.MALL_ORDER_DETAILS}/${this.props.orderId}`)
  }

  onOrderPay = () => {
    this.props.onOrderClick('pay', this.props.orderId)
  }

  onOrderCancel = () => {
    this.props.onOrderClick('cancel', this.props.orderId)
  }

}

export { OrderListItem }
